<kendo-dialog
  title="Зберегти запис на прийом?"
  *ngIf="form"
  (close)="cancel()"
  autoFocusedElement="#username"
  [width]="450"
>
  <div class="example" >
    <form class="k-form" [formGroup]="form">
      <fieldset class="k-form-fieldset">
        <legend *ngIf="errMessage" class="k-form-legend" style="color:red;">{{errMessage}}</legend>

        <input type="hidden" formControlName="patientId" />
        <input type="hidden" formControlName="medicalAppointmentQueueId" />

        <kendo-formfield>
          <kendo-label [for]="lastName" text="Прізвище"></kendo-label>
          <kendo-textbox
            formControlName="lastName"
            [clearButton]="true"
            [readonly]="!!patientDetails?.id"
            #lastName
            required
          ></kendo-textbox>
          <kendo-formerror>Обов'язкове поле</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [for]="firstName" text="Ім'я"></kendo-label>
          <kendo-textbox
            formControlName="firstName"
            [clearButton]="true"
            [readonly]="!!patientDetails?.id"
            #firstName
            required
          ></kendo-textbox>
          <kendo-formerror>Обов'язкове поле</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [for]="patronymic" text="По батькові"></kendo-label>
          <kendo-textbox
            formControlName="patronymic"
            [clearButton]="true"
            [readonly]="!!patientDetails?.id"
            #patronymic
          ></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [for]="phone1" text="Телефон"></kendo-label>
          <kendo-maskedtextbox
            formControlName="phone1"
            [readonly]="!!patientDetails?.id"
            #phone1
            required
            pattern="[0-9]{10}"
            mask="+38 0000000000"
          ></kendo-maskedtextbox>
          <kendo-formerror>Обов'язкове поле, 10 цифр</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [for]="doctorAndSpecialty" text="Прийом до"></kendo-label>
          <kendo-textbox
            formControlName="doctorAndSpecialty"
            [readonly]="true"
            #doctorAndSpecialty
          ></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [for]="dateAndTime" text="Дата та час"></kendo-label>
          <kendo-textbox
            formControlName="dateAndTime"
            [readonly]="true"
            #dateAndTime
          ></kendo-textbox>
        </kendo-formfield>
        
        <kendo-formfield>
          <kendo-label [for]="comment" text="Примітка"></kendo-label>
          <kendo-textarea
            formControlName="comment"
            #comment
          ></kendo-textarea>
        </kendo-formfield>


        <kendo-dialog-actions>
          <div *ngIf="intervalCounter < 600; else timePassed" class="fl-l alert-danger m-0 p-5">
            Резерв 10 хв. <br />
            Залишилося {{ (600 - intervalCounter) * 1000 | date:'mm:ss' }} хв. 
          </div>
          <ng-template #timePassed>
            <div class="fl-l alert-danger m-0 p-5">
              Резерв 10 хв. вичерпано. <br />
              Запис доступний іншим.
            </div>
          </ng-template>

          <div class="k-form-buttons fl-r display-block t-a-right">
            <button kendoButton themeColor="primary" [disabled]="form.invalid" (click)="save()">Так</button>
            <button kendoButton (click)="cancel()" class="m-l-5">Ні</button>
          </div>

        </kendo-dialog-actions>
      </fieldset>
    </form>
  </div>
</kendo-dialog>

<!-- 
<button
  kendoButton
  *ngIf="!dialogOpened"
  (click)="dialogOpened = !dialogOpened"
>
  Open dialog
</button>

  
  
<kendo-dialog
  title="Please confirm"
  *ngIf="dialogOpened"
  (close)="dialogOpened = !dialogOpened"
  autoFocusedElement="#username"
  [width]="450"
>
  <div class="example" >
    <form class="k-form" [formGroup]="form">
      <fieldset class="k-form-fieldset">
        <legend class="k-form-legend">Your account</legend>

        <hr *ngIf="fv" />
        {{ fv | json }}
        <hr *ngIf="fv" />

        <kendo-formfield>
          <kendo-label [for]="username" text="Username"></kendo-label>
          <kendo-textbox
            formControlName="username"
            [clearButton]="true"
            #username
            required
          ></kendo-textbox>
          <kendo-formhint>Your Username</kendo-formhint>
          <kendo-formerror>Error: Username is required</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [for]="password" text="Password"> </kendo-label>
          <kendo-textbox
            formControlName="password"
            #password
            required
            [clearButton]="true"
          >
            <ng-template kendoTextBoxSuffixTemplate>
              <button
                kendoButton
                look="clear"
                icon="eye"
                (click)="toggleVisibility()"
              ></button>
            </ng-template>
          </kendo-textbox>
          <kendo-formhint>Your password</kendo-formhint>
          <kendo-formerror>Error: Password is required</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
          <div class="k-checkbox-wrap">
            <input
              #loggedin
              type="checkbox"
              kendoCheckBox
              formControlName="loggedin"
            />
            <kendo-label
              [for]="loggedin"
              class="k-checkbox-label"
              text="Keep me logged in"
            ></kendo-label>
          </div>
          <kendo-formhint>Next time, you will be logged in automatically</kendo-formhint>
        </kendo-formfield>

        <kendo-dialog-actions [layout]="actionsLayout">
          <div class="k-form-buttons">
            <button kendoButton themeColor="primary" (click)="login()">Login</button>
            <button kendoButton (click)="clearForm()">Clear</button>
          </div>
        </kendo-dialog-actions>
      </fieldset>
    </form>
  </div>
</kendo-dialog> -->